import Vue from 'vue'
import Router from 'vue-router'
import ViewContainer from './views/ViewContainer.vue'
import All from './views/All.vue'
import AppDetail from './views/AppDetail.vue'
import Downloads from './views/Downloads.vue'
import AutodeskSoftware from './views/AutodeskSoftware.vue'
import MyFavorites from './views/MyFavorites.vue'
import Landing from './views/Landing.vue'
import SearchResults from './views/SearchResults.vue'
import Callback from './views/Callback.vue'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (window.scrollY > 400) {   
      return { x: 0, y: 300 }
    }
  },
  routes: [
    {
      path: '/callback',
      name: 'callback',
      component: Callback
    },
    {
      path: '/view/easier-3-autodesk-software',
      name: 'easier-3-autodesk-software',
      component: AutodeskSoftware
    },
    {
      path: '/view/*',
      name: 'viewContainer',
      component: ViewContainer
    },
    {
      path: '/search',
      name: 'searchView',
      component: SearchResults
    },
    {
      path: '/view-app/:id',
      name: 'appView',
      component: AppDetail
    },
    {
      path: '/my-favorites',
      name: 'myFavorites',
      component: MyFavorites
    },
    {
      path: '/downloads',
      name: 'downloads',
      component: Downloads
    },
    {
      path: '/all',
      name: 'all',
      component: All
    },
    {
      path: '*',
      name: 'landing',
      component: Landing
    }
  ]
})
// set meta analytics before each route for metrics tracking
router.beforeEach((to, from, next) => {
  
  store.commit('setPreviousRoute', from)
  to.meta.analytics = to.path + (to.query && to.query.q? '?q='+to.query.q:'')
  next()
})

export default router
